import React from 'react';
import './SummaryBanner.css';

const SummaryBanner = ({ scanData }) => {
  const summary = scanData?.summary || {};
  
  return (
    <div className="summary-banner">
      {summary.site_outdated && (
        <div className="summary-item warning">
          <span className="summary-icon">⚠</span>
          <div className="summary-text">
            <strong>Site is Outdated.</strong> Our scanner didn't detect any malware.
          </div>
        </div>
      )}
      {summary.not_blacklisted && (
        <div className="summary-item success">
          <span className="summary-icon">✓</span>
          <div className="summary-text">
            <strong>Site is not Blacklisted.</strong> {summary.blacklist_count || 9} Blacklists checked.
          </div>
        </div>
      )}
    </div>
  );
};

export default SummaryBanner;

